<div *ngIf="bookings">
    <div class="group-panel">
        <div class="row uncollapse group-header">
            <div class="column small-2 hide-for-medium-down">
                <h5>{{ 'AMENDMENT_TABLE_HEADER_RESERVATION_ID' | resource }}</h5>
            </div>
            <div class="column small-2 hide-for-medium-down">
                <h5>{{ 'AMENDMENT_TABLE_HEADER_OUTBOUND_DATE' | resource }}</h5>
            </div>
            <div class="column small-2 hide-for-medium-down">
                <h5>{{ 'AMENDMENT_TABLE_HEADER_RETURN_DATE' | resource }}</h5>
            </div>
            <div class="column small-2 hide-for-medium-down">
                <h5>{{ 'AMENDMENT_TABLE_HEADER_ROUTE' | resource }}</h5>
            </div>
            <div class="column small-2 hide-for-medium-down">
                <h5>{{ 'AMENDMENT_TABLE_HEADER_NUMBER_OF_PASSENGERS' | resource }}</h5>
            </div>
            <div class="column small-2 hide-for-medium-down">
                <h5>{{ 'AMENDMENT_TABLE_HEADER_VEHICLE_TYPE' | resource }}</h5>
            </div>
        </div>
        <div class="all-bookings">
            <div class="row uncollapse group-item" *ngFor="let booking of displayedBookings" [attr.data-routecode]="booking.routeCode" [attr.data-reservationcode]="booking.code" [attr.data-e2e-reservationstatus]="booking.status">
                <a class="anonymous" [routerLink]="routerAction(booking)" (click)="changeStep()" >
                    <div *ngIf="true;then linkContent"> </div>
                </a>
                <ng-template #linkContent>
                    <div class="column small-12 large-2">
                        <div class="row">
                            <div class="column small-4 hide-for-large-up option-text">
                                <h5>{{ 'AMENDMENT_TABLE_HEADER_RESERVATION_ID' | resource }}</h5>
                            </div>
                            <div class="column small-8 large-12 option-count booking-code">
                                {{ booking.code }}
                            </div>
                        </div>
                    </div>

                    <div class="column small-12 large-2">
                        <div class="row">
                            <div class="column small-4 hide-for-large-up option-text">
                                <h5>{{ 'AMENDMENT_TABLE_HEADER_OUTBOUND_DATE' | resource }}</h5>
                            </div>
                            <div class="column small-8 large-12 option-count">
                                {{ booking.departureDate | jodaDateFormatter:'dd/MM/yyyy' }}
                            </div>
                        </div>
                    </div>

                    <div class="column small-12 large-2">
                        <div class="row">
                            <div class="column small-4 hide-for-large-up option-text">
                                <h5>{{ 'AMENDMENT_TABLE_HEADER_RETURN_DATE' | resource }}</h5>
                            </div>
                            <div class="column small-8 large-12 option-count">
                                <span *ngIf="!booking.departureDate.equals(booking.returnDate)">{{ booking.returnDate | jodaDateFormatter:'dd/MM/yyyy' }}</span>
                                <span *ngIf="booking.departureDate.equals(booking.returnDate)">&nbsp;</span> <!-- the space is to prevent e2e test from faiing when it sometimes clicks the return data. And yes returnDate on oneways are the same as the departureDate-->
                            </div>
                        </div>
                    </div>

                    <div class="column small-12 large-2">
                        <div class="row">
                            <div class="column small-4 hide-for-large-up option-text">
                                <h5>{{ 'AMENDMENT_TABLE_HEADER_ROUTE' | resource }}</h5>
                            </div>
                            <div class="column small-8 large-12 option-count">
                                {{ booking.route }}
                            </div>
                        </div>
                    </div>

                    <div class="column small-12 large-2">
                        <div class="row">
                            <div class="column small-4 hide-for-large-up option-text">
                                <h5>{{ 'AMENDMENT_TABLE_HEADER_NUMBER_OF_PASSENGERS' | resource }}</h5>
                            </div>
                            <div class="column small-8 large-12 option-count">
                                <span *ngIf="booking.adults > 0">
                                            {{booking.adults}} {{ 'ADULTS' | resource }}
                                        </span>
                                <span *ngIf="booking.children > 0">
                                            , {{booking.children}} {{ 'CHILDREN' | resource }}
                                        </span>
                                <span *ngIf="booking.infants > 0">
                                            , {{booking.infants}} {{ 'INFANTS' | resource }}
                                        </span>
                            </div>
                        </div>
                    </div>

                    <div class="column small-12 large-2">
                        <div class="row">
                            <div class="column small-4 hide-for-large-up option-text">
                                <h5>{{ 'AMENDMENT_TABLE_HEADER_VEHICLE_TYPE' | resource }}</h5>
                            </div>
                            <div class="column small-8 large-12 option-count">
                                {{ booking.vehicle }}
                            </div>
                        </div>
                    </div>
                </ng-template>
            </div>
        </div>
    </div>

    <div *ngIf="hasMore" class="row class show-more-container">
        <div class="column">
            <div class="text-center">
                <a (click)="showMore()" class="button expand show-more">
                    <i class="down-arrow">&nbsp;</i> {{'AMENDMENT_SHOW_MORE' | resource}} <i class="down-arrow">&nbsp;</i>
                </a>
            </div>
        </div>
    </div>

</div>
